import styled from 'styled-components';

import DroppableTileList from './DroppableTileList.jsx';
import { TabWithPlaceholder } from './TabWithPlaceholder.jsx';
import { TilesWrapper } from '../StyledComponents';

const DroppableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const ProofTabContainer = ({
  activeFilters,
  activeStatus,
  addTileToDigest,
  changeTileStatus,
  handleMenuAction,
  isUserSiteAdmin,
  moveTileBackToPlan,
  tiles,
  dndContext,
  pageNumber,
}) => {
  return (
    <TabWithPlaceholder tiles={tiles}>
      <TilesWrapper>
        <DroppableContainer>
          <DroppableTileList
            activeFilters={activeFilters}
            activeStatus={activeStatus}
            addTileToDigest={addTileToDigest}
            canAddTile={false}
            changeTileStatus={changeTileStatus}
            handleMenuAction={handleMenuAction}
            hasEmptyTileFillers={true}
            isUserSiteAdmin={isUserSiteAdmin}
            moveTileBackToPlan={moveTileBackToPlan}
            tileDigestPlanDate={null}
            tiles={tiles}
            dndContext={dndContext}
            pageNumber={pageNumber}
            pageSize={tiles.length}
            showAllItems={true}
          />
        </DroppableContainer>
      </TilesWrapper>
    </TabWithPlaceholder>
  );
};
